import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { goLoginEmail, outLogin, goLogin } from '../api/apply'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: getToken()
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    }
  },
  actions: {
    // user login
    login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        goLogin(userInfo).then(data => {
          if (data.code == 200) {
            commit('SET_TOKEN', data.token)
            setToken(data.token)
          }
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // user login
    loginEmail ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        goLoginEmail(userInfo).then(data => {
          if (data.code == 200) {
            commit('SET_TOKEN', data.token)
            setToken(data.token)
          }
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // user logout
    logout ({ commit, state }) {
      return new Promise((resolve, reject) => {
        outLogin().then(() => {
          commit('SET_TOKEN', '')
          localStorage.removeItem('login_user')
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  modules: {},
  getters: {
    token: state => state.token
  }
})
